module.exports = __webpack_public_path__ + "d4549e713c6ea8eae0ae12226beab5e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/floor_items/wand.png
// module id = 2797
// module chunks = 0